import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { Icon, Toaster } from '../ui';
import './layout.css';

/** 경로가 바뀌면 맨 위로. 해시가 있으면 해당 요소로. */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);
  return null;
}

function Floating() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <aside className="floating" aria-label="Quick actions">
      <Link to="/contact" className="floating-btn floating-btn--brand" aria-label="Contact us" title="Contact us">
        <Icon name="message" size={20} />
      </Link>
      <button
        type="button"
        className={`floating-btn ${show ? '' : 'is-hidden'}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Back to top"
        title="Back to top"
      >
        <Icon name="arrowUp" size={20} />
      </button>
    </aside>
  );
}

export default function AppLayout() {
  return (
    <>
      <ScrollToTop />
      <a href="#main" className="skip-link">Skip to content</a>
      <Header />
      <main className="app-main" id="main" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <Floating />
      <Toaster />
    </>
  );
}
